module.exports = __webpack_public_path__ + "static/media/Sokk-min.64dbd871.PNG";